var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFullStar = function SvgFullStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.528.359a.5.5 0 0 1 .944 0l1.53 4.4a.5.5 0 0 0 .462.336l4.657.095a.5.5 0 0 1 .292.898l-3.712 2.814a.5.5 0 0 0-.176.543l1.348 4.46a.5.5 0 0 1-.764.555l-3.823-2.661a.5.5 0 0 0-.572 0l-3.823 2.66a.5.5 0 0 1-.765-.555l1.35-4.459a.5.5 0 0 0-.177-.543L.587 6.088a.5.5 0 0 1 .292-.898l4.657-.095a.5.5 0 0 0 .462-.336l1.53-4.4Z",
    fill: "#F1BA5A"
  })));
};
export default SvgFullStar;